import React from "react";
import { pushRotate as Menu } from "react-burger-menu";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { loadInitClientData } from "../../actions/authActions";
import { getuserInfomation } from "../../actions/authActions";
// import * as actionsCreators from "../actions";
// import { Routes } from '../../../constants/routeConstants';
import * as actionCreators from "../../actions/authActions";
import * as authSelectors from "../../selectors/authSelectors";
import {RELEATIVE_PATH} from  '../../config';

import {
  getIsAuthenticated,
  getIsSignUp,
  getUserName,
  getUser,
} from "../../selectors/authSelectors";

import "./mymenu.css";
class MyMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  componentDidMount() {
    // getuserInfomation();
  }
  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen });
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  toggleMenu() {
    this.setState((state) => ({ menuOpen: !state.menuOpen }));
  }
  showSettings(event) {
    event.preventDefault();
  }

  render() {
    const styles = {
      bmBurgerButton: {
        position: "fixed",
        width: "36px",
        height: "30px",
        right: "36px",
        top: "36px",
        left: "unset",
      },
      bmBurgerBars: {
        background: "#fff",
      },
      bmBurgerBarsHover: {
        background: "#a90000",
      },

      bmMenuWrap: {
        position: "fixed",
        height: "100%",
        boxShadow:
          "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
      },
    };
    const onLogout = () => {
      this.closeMenu();
      this.props.actions.kickOut();
    };
    const name = this.props?.user?.accounts?.name;
    const email = this.props?.user?.accounts?.email;
    const defaultProject = this.props?.user?.accounts?.defaultProject;
    // const {name, email, defaultProject}  = user;
    return (
      <>
        {this.props.isAuthenticated && this.props.user && (
          <Menu
            styles={styles}
            pageWrapId={"page-wrap"}
            outerContainerId={"outer-container"}
            right
            disableAutoFocus
            isOpen={this.state.menuOpen}
            onStateChange={(state) => this.handleStateChange(state)}
            id={"pushRotate"}
          >
            <NavLink
              className="menu-item"
              to="#"
              // to={`${RELEATIVE_PATH}user-settings`}
              onClick={() => this.closeMenu()}
            >
              <div className="div-center sidebar-item__title">
                <div className="proifle-info">
                  {name && name[0].toUpperCase()}
                </div>
              </div>
            </NavLink>
            <div className="email" title="user mail id">
              {email}
              <span className="menu-pd" title="default project name">
                ({defaultProject})
              </span>
            </div>
            <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}dashboard`}
              onClick={() => this.closeMenu()}
            >
              Home
            </NavLink>
            <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}aa`}
            
              onClick={() => this.closeMenu()}
            >
              Automation Dashboard
            </NavLink> 
             <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}automation-execution`}
            
              onClick={() => this.closeMenu()}
            >
              Automation Execution
            </NavLink>
            <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}upgrade-status`}
              onClick={() => this.closeMenu()}
            >
              Customer Upgrade
            </NavLink>
            <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}quintessential-status`}
              onClick={() => this.closeMenu()}
            >
              Quintessential Status
            </NavLink>
            <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}test-repository`}
              onClick={() => this.closeMenu()}
            >
              Test Repository
            </NavLink>
            <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}code-builder`}
              onClick={() => this.closeMenu()}
            >
              Code Builder
            </NavLink>
            <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}reference-library`}
              onClick={() => this.closeMenu()}
            >
              Reference Libraries
            </NavLink>
            <NavLink
              className="menu-item"
              to={`${RELEATIVE_PATH}community`}
           
              onClick={() => this.closeMenu()}
            >
              Community
            </NavLink>
            <NavLink exact className="menu-item" 
              to={`${RELEATIVE_PATH}`}
           
            onClick={onLogout}>
              Logout
            </NavLink>
          </Menu>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: getIsAuthenticated(state),
    user: getUser(state),
    // email: getEmail(state),
    // project: getProject(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    actions: bindActionCreators(actionCreators, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyMenu);
